import { getToken, getUser, getRestoLogin } from "../Utils/Common";
import {
    getWithParamsAPICall,
} from "./axiosMethodCalls";

const API_URL =
  getRestoLogin() === "happyhippos"
    ? process.env.REACT_APP_BRIQUE_API
    : process.env.REACT_APP_ETTAS_API;

export const getCashCounts = async () => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
        };
      
        const response = await getWithParamsAPICall(
            API_URL + "cash_counts/getAll",
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const showCashCount = async (id) => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
        };
      
        const response = await getWithParamsAPICall(
            API_URL + "cash_counts/show/"+id,
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const getQRrManual = async (date_from, date_to) => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
            date_from:date_from,
            date_to:date_to,
        };
      
        const response = await getWithParamsAPICall(
            API_URL + "reports/qrAndManualCount",
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};


export const getZReading = async (type,date_from, date_to, restoType) => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
            date_from:date_from,
            date_to:date_from,
            type: type,
        };
      
        const response = restoType === "happyhippos" ? await getWithParamsAPICall(
            process.env.REACT_APP_BRIQUE_API + "reports/zreading",
            payload
        ) : await getWithParamsAPICall(
            process.env.REACT_APP_ETTAS_API + "reports/zreading",
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const getAuditTrails = async (date_from, date_to) => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
            date_from:date_from,
            date_to:date_to,
        };
      
        const response = await getWithParamsAPICall(
            API_URL + "reports/auditTrails",
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const generateAudit = async (date_to) => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
            date:date_to,
        };
      
        const response = await getWithParamsAPICall(
            API_URL + "reports/generateAuditTrails",
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const getCancelledItems = async (type, date_from, date_to) => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
            date_from:date_from,
            date_to:date_to,
            type: type,
        };
      
        const response = await getWithParamsAPICall(
            API_URL + "reports/cancelledItems",
            payload
        );
        return { data: response.data  };
    } catch (error) {
        return { error: error.response };
    }
};


export const getCategoryReport = async (filter, restoType) => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
            date_from: filter.date_from,
            date_to: filter.date_to,
            category_id: filter.category_id,
            pricelist: filter.pricelist
        };
      
        const response = restoType==="happyhippos"?await getWithParamsAPICall(
            process.env.REACT_APP_BRIQUE_API + "reports/category",
            payload
        ):await getWithParamsAPICall(
            process.env.REACT_APP_ETTAS_API + "reports/category",
            payload
        );
        return { data: response.data  };
    } catch (error) {
        return { error: error.response };
    }
};



